import _ from 'lodash';
import { MRT_RowData } from 'material-react-table';

const average = (data: MRT_RowData[], column: string) => {
	const sum = data.reduce(
		(acc: number, row) => acc + Number(extractNumber(row[column])),
		0
	);
	const count = data.length;
	return !isNaN(sum) ? `${_.round(sum / count,2)}` : '-';
};

const extractNumber = (inputString: any) => {
	// Use a regular expression to match the numeric part, including decimals
	if (typeof inputString === 'string') {
		const match = inputString.match(/[\d,]+(\.\d{1,2})?/);
		return match ? match[0] : 0;
	}
	return inputString;
};
const sum = (data: MRT_RowData[], column: string) => {
	const sum = data.reduce(
		(acc: number, row) => acc + Number(extractNumber(row[column])),
		0
	);
	return !isNaN(sum) ? `${_.round(sum,2)}` : '-';
};

const max = (data: MRT_RowData[], column: string) => {
	const maxVal = Math.max(...data.map((row) => Number(row[column])));
	return `${maxVal}`;
};

const countEmpty = (data: MRT_RowData[], column: string) => {
	const empty = data?.filter((d) => {
		const value = _.get(d, column); 
		return isNaN(Number(value)) 
			? Boolean(!_.size(value)) 
			: Boolean(!Number(value))
	}
	);
	return `${empty.length}`;
};

const percentageEmpty = (data: MRT_RowData[], column: string) => {
	const empty = data?.filter((d) => {
		const value = _.get(d, column); 
		return isNaN(Number(value))
			? Boolean(!_.size(value))
			: Boolean(!Number(value))
	}
	);
	const percentage = (empty.length / data.length) * 100;

	return `${_.round(percentage,2)}%`;
};

const percentageFull = (data: MRT_RowData[], column: string) => {
	const full = data?.filter((d) => {
		const value = _.get(d, column); 
		return isNaN(Number(value))
			? Boolean(_.size(value))
			: Boolean(Number(value))
	}
	);
	const percentage = (full.length / data.length) * 100;

	return `${_.round(percentage,2)}%`;
};

const countFull = (data: MRT_RowData[], column: string) => {
	const full = data?.filter((d) => {
		const value = _.get(d, column); 
		return isNaN(Number(value))
			? Boolean(_.size(value))
			: Boolean(Number(value))
	}
	);
	return `${full.length}`;
};

const none = () => {
	return null;
};

const min = (data: MRT_RowData[], column: string) => {
	const minValue = Math.min(...data.map((row) => Number(row[column])));
	return `${minValue}`;
};

export const aggregationFns = {
	none,
	min,
	max,
	sum,
	average,
	countEmpty,
	countFull,
	percentageEmpty,
	percentageFull
};
